<seb-table-filter-subject #subjectFilter 
  (evFilter)="onFilter($event)" [filterSubject]="filterSubject">
</seb-table-filter-subject>

<seb-lex-table
  #SubjectTable
  [columns]="subjectsTable.columns"
  [data]="subjectsTable.data"
  [showPagination]="true"
  [disableLineClick]="true"
  [paginationSize]="paginationSize"
  [preloader]="preloader"
  (sortColumn)="onOrder($event)"
  (changePage)="onIndexPag($event)"
  (actionButton)="actionButtonGroup($event)"
>
</seb-lex-table>
